import Heading from '@pelckmans/elementis/components/heading';
import { OrderedList, UnorderedList } from '@pelckmans/elementis/components/lists';
import Paragraph from '@pelckmans/elementis/components/paragraph';
import { Cell } from '@pelckmans/elementis/components/table';
import { useRoutes } from '../../../hooks/useRoutes';
import PrivacyTableCell from './components/PrivacyTableCell';

function ContentNL() {
  const { getRoute } = useRoutes();

  return (
    <div className="break-word privacy-page">
      <Paragraph>Laatst bijgewerkt op 5/01/2024.</Paragraph>
      <div id="privacy-policy" />
      <Heading level={2}>Privacy Policy</Heading>
      <Heading level={3}>Over deze privacyverklaring</Heading>
      <Paragraph>
        Pelckmans Portaal (hierna genoemd “we”) staat voor onderwijsvernieuwing en is toonaangevend inzake didactische
        concepten.
      </Paragraph>
      <Paragraph>
        We hechten veel belang aan het respecteren van de persoonlijke levenssfeer van onze klanten en bezoekers (hierna
        genoemd “je”) van onze websites. Daarom informeren we je duidelijk over de voorzorgen en maatregelen die we
        nemen bij de behandeling van jouw persoonlijke gegevens.
      </Paragraph>
      <Paragraph>
        We stellen dit privacybeleid vast, dat tot doel heeft jouw persoonsgegevens op een wettelijke, correcte en
        transparante manier te verwerken, geheel in lijn met de Wet van 30 juli 2018 en de Verordening (EU) 2016/679.
      </Paragraph>
      <Paragraph>In dit privacybeleid leggen we, onder andere, uit:</Paragraph>
      <OrderedList type="A">
        <li>Wie we zijn</li>
        <li>Welke persoonsgegevens we verzamelen en verwerken, en waarom we dat doen</li>
        <li>Jouw toestemming met de verwerking van jouw persoonsgegevens</li>
        <li>Welke rechten je hebt en hoe je die kan uitoefenen</li>
        <li>Hoelang jouw persoonsgegevens worden bewaard</li>
        <li>Met wie we bepaalde gegevens delen en waarom we dat doen</li>
        <li>Wijzigingen aan deze privacyverklaring</li>
      </OrderedList>
      <Heading level={3}>A. Wie zijn we?</Heading>
      <Paragraph>
        Pelckmans Portaal maakt deel uit van Pelckmans Uitgevers NV en is een onderneming met adres te
        Brasschaatsteenweg (C) 308, 2920 Kalmthout (België) met:
      </Paragraph>
      <Paragraph>KBO/BTW: 0444.548.723</Paragraph>
      <Paragraph>
        E-mail: <a href="mailto:helpdesk@pelckmans.be">helpdesk@pelckmans.be</a>
      </Paragraph>
      <Paragraph>Telefoon: +32 3 660 27 20</Paragraph>
      <Paragraph>
        Wanneer je voor school/centrum gebruik moet (of mag) maken van digitale leermiddelen beschikbaar op onze
        websites, verwerken we enkel jouw persoonsgegevens in opdracht van de school/centrum. De school/centrum is dan
        verantwoordelijk voor de verwerking van jouw gegevens en dus het aanspreekpunt om jouw rechten uit te oefenen.
        In alle andere gevallen zijn we zelf verwerkingsverantwoordelijke. Onze contactgegevens staan hierboven vermeld.
      </Paragraph>
      <Paragraph>De volgende websites worden bedoeld:</Paragraph>
      <UnorderedList>
        <li>
          <a href="https://www.pelckmansportaal.be">https://www.pelckmansportaal.be</a>;
        </li>
        <li>
          <a href="https://www.pelckmansportail.be">https://www.pelckmansportail.be</a>;
        </li>
        <li>
          <a href="https://basis.pelckmans.be">https://basis.pelckmans.be</a>;
        </li>
        <li>
          <a href="https://leerkracht-basis.pelckmans.be">https://leerkracht-basis.pelckmans.be</a>;
        </li>
        <li>
          <a href="https://zogezegd.pelckmans.be">https://zogezegd.pelckmans.be</a>.
        </li>
      </UnorderedList>
      <Heading level={3}>
        B. De persoonsgegevens die worden verwerkt en het doel van de verwerking van persoonsgegevens
      </Heading>
      <Paragraph>
        Wanneer je één van onze websites bezoekt, en/of je je registreert zullen we jouw persoonsgegevens opslaan en
        gebruiken om onze diensten en/of producten te kunnen aanbieden. Meer concreet, verzamelen en verwerken we, onder
        andere, de volgende persoonsgegevens:
      </Paragraph>
      <UnorderedList>
        <li>voor- en achternaam</li>
        <li>school/centrum en/of klas/cursus</li>
        <li>e-mail.</li>
      </UnorderedList>
      <Paragraph>
        We gebruiken ook tools om het surf- en klikgedrag op onze websites te kennen, onder meer door cookies. Op die
        manier hoef je eenzelfde webformulier niet twee keer in te vullen en kan jouw gebruikservaring op de website
        optimaal verlopen. Ons cookiebeleid kan je <a href={`${getRoute('PRIVACY_POLICY')}#cookies`}>hier</a> lezen.
      </Paragraph>
      <Paragraph>We verwerken jouw persoonsgegevens enkel in één van de volgende gevallen:</Paragraph>
      <UnorderedList>
        <li>
          wanneer je ons jouw uitdrukkelijke toestemming hebt gegeven voor de afname ervan, of wanneer de verwerking
          noodzakelijk is;
        </li>
        <li>voor de uitvoering van een overeenkomst;</li>
        <li>om te voldoen aan een wettelijke of reglementaire verplichting;</li>
        <li>
          het beantwoorden van elke gegronde vraag van de subsidiërende of toezichthoudende overheid om toegang te
          krijgen tot de gegevens;
        </li>
        <li>voor de behartiging van onze gerechtvaardigde belangen of van een derde;</li>
        <li>voor de administratie en boekhouding.</li>
      </UnorderedList>
      <Heading level={3}>C. Toestemming </Heading>
      <Paragraph>
        Door toegang tot en het gebruik van onze websites verklaar je dat je dit privacybeleid hebt gelezen en je ons
        jouw vrije, specifieke, geïnformeerde en ondubbelzinnige toestemming voor de verwerking van jouw
        persoonsgegevens hebt gegeven.
      </Paragraph>
      <Paragraph>Toestemming wordt gegeven wanneer je het vakje voor het privacybeleid hebt aangevinkt.</Paragraph>
      <Paragraph>
        Elke overeenkomt die ons verbindt met betrekking tot de diensten en/of producten die worden aangeboden op onze
        website is onderworpen aan jouw aanvaarding van dit beleid.
      </Paragraph>
      <Paragraph>
        Je stemt ermee in dat we, in overeenstemming met de voorwaarden en principes in dit beleid opgenomen, jouw
        persoonlijke gegevens verzamelen en verwerken die je op de website of in verband met de diensten en/of producten
        die we aanbieden, verstrekt voor de hierboven vermelde doeleinden.
      </Paragraph>
      <Paragraph>
        Voor wat betreft de mogelijkheid tot intrekking van jouw toestemming verwijzen we naar punt D. “Jouw rechten
        zijn gewaarborgd”.
      </Paragraph>
      <Heading level={3}>D. Jouw rechten zijn gewaarborgd</Heading>
      <Paragraph>
        We zorgen ervoor dat je de controle behoudt over jouw gegevens en dat je altijd jouw rechten kan uitoefenen.
      </Paragraph>
      <Paragraph>Je geniet de volgende rechten met betrekking tot jouw persoonsgegevens:</Paragraph>
      <UnorderedList>
        <li>Het recht op inzage:</li>
      </UnorderedList>
      <Paragraph>
        Je hebt het recht om op elk moment gratis kennis te nemen van jouw persoonsgegevens, alsook van het gebruik dat
        we van jouw persoonsgegevens maken.
      </Paragraph>
      <UnorderedList>
        <li>Het recht op rectificatie, op wissing en beperking van de verwerking:</li>
      </UnorderedList>
      <Paragraph>
        Je bent vrij om jouw persoonsgegevens al dan niet aan ons mee te delen. Daarnaast heb je steeds het recht om ons
        te verzoeken jouw persoonsgegevens te verbeteren, aan te vullen of te verwijderen. Je mag eveneens vragen om de
        verwerking van jouw persoonsgegevens te beperken. Andere wetten die ons verplichten om bepaalde data te bewaren
        gaan echter voor op deze regel.
      </Paragraph>
      <UnorderedList>
        <li>Het recht op bezwaar:</li>
      </UnorderedList>
      <Paragraph>
        Je beschikt eveneens over een recht van verzet tegen de verwerking van jouw persoonsgegevens om ernstige en
        legitieme redenen.
      </Paragraph>
      <UnorderedList>
        <li>Het recht op gegevensoverdraagbaarheid:</li>
      </UnorderedList>
      <Paragraph>
        Je beschikt over het recht om jouw persoonsgegevens die door ons verwerkt worden in gestructureerde, gangbare en
        machine leesbare vorm te verkrijgen en/of aan andere verantwoordelijken over te dragen.
      </Paragraph>
      <UnorderedList>
        <li>Het recht op intrekking van uw toestemming:</li>
      </UnorderedList>
      <Paragraph>
        Voor zover de verwerking gebaseerd is op jouw voorafgaande toestemming, beschik je over het recht om die
        toestemming in te trekken. Je hebt te allen tijde het recht om deze toestemming in te trekken. De intrekking van
        de toestemming laat de rechtmatigheid van de verwerking op basis van de voorafgaande toestemming onverlet.
      </Paragraph>
      <UnorderedList>
        <li>Het recht op klachtindiening:</li>
      </UnorderedList>
      <Paragraph>
        Mocht je het niet eens zijn met hoe we jouw verzoek behandelen, dan kan je je richten tot de
        gegevensbeschermingsautoriteit (Commissie voor de Bescherming van de Persoonlijke Levenssfeer, Drukpersstraat
        35, 1000 Brussel, Tel +32 (0)2 274 48 00, Fax +32 (0)2 274 48 35, e-mail:{' '}
        <a href="mailto:contact@apd-gba.be">contact@apd-gba.be</a>
        ). Dit laat een voorziening voor een burgerlijke rechtbank onverlet.
      </Paragraph>
      <Paragraph>
        Indien je schade zou lijden als gevolg van de verwerking van jouw persoonsgegevens, kan je een vordering tot
        schadevergoeding instellen.
      </Paragraph>
      <Paragraph>
        Indien je jouw rechten wilt uitoefenen of daarover een vraag hebt, kan je met ons contact opnemen:{' '}
        <a href="mailto:helpdesk@pelckmans.be">helpdesk@pelckmans.be</a>
      </Paragraph>
      <Paragraph>
        We zullen dan wel een aantal gegevens van je opvragen, bijvoorbeeld jouw identiteitskaart, zodat we zeker zijn
        dat niemand anders jouw rechten probeert uit te oefenen.
      </Paragraph>
      <Paragraph>
        De verwerking van jouw persoonsgegevens omvat geen profiling en je zal door ons evenmin aan geautomatiseerde
        beslissingen worden onderworpen.
      </Paragraph>
      <Heading level={3}>E. Hoe lang bewaren we persoonsgegevens?</Heading>
      <Paragraph>
        We bewaren jouw gegevens slechts zolang nodig is om je te voorzien van onze diensten en/of producten en, hierna,
        voor een in de tijd beperkte periode.
      </Paragraph>
      <Paragraph>
        We zullen, bijvoorbeeld, een beoordeling maken met wie we nog een actieve relatie hebben die de bewaring van
        persoonsgegevens rechtvaardigt. Is dat niet langer het geval, dan verwijderen we jouw gegevens uit ons database.
      </Paragraph>
      <Heading level={3}>F. Welke partijen kunnen jouw gegevens ontvangen?</Heading>
      <Paragraph>
        We zorgen ervoor dat enkel personen jouw gegevens kunnen zien als die relevant zijn om de taken te vervullen,
        zoals bijvoorbeeld met je communiceren over de uitvoering en afhandeling van onze diensten en/of producten.
      </Paragraph>
      <Paragraph>
        We nemen intern technische en organisatorische maatregelen om te voorkomen dat jouw persoonsgegevens in handen
        komen van en verwerkt worden door onbevoegden, of per ongeluk gewijzigd of vernietigd worden. De lokalen, de
        servers, het netwerk, de overdrachten en de gegevens worden strikt beveiligd.
      </Paragraph>
      <Paragraph>
        Dit is echter geen absolute garantie. Voor meer informatie of bij aanwijzingen van misbruik, kan je altijd
        contact met ons opnemen via <a href="mailto:helpdesk@pelckmans.be">helpdesk@pelckmans.be</a>
      </Paragraph>
      <Paragraph>De volgende partijen ontvangen jouw persoonsgegevens:</Paragraph>
      <Heading level={4}>1. Partners :</Heading>
      <Paragraph>In het kader van een specifieke samenwerking met:</Paragraph>
      <UnorderedList>
        <li>
          Smartschool – Smartbit BV, met adres te Muizendijkstraat 124, 3960 Bree (België), en met BTW-nummer
          0479.803.174;
        </li>
        <li>
          AssesmentQ – Televic Education HQ, met adres te Leo Bekaertlaan 1 8870 Izegem (België), en met BTW-nummer
          0405.314.795;
        </li>
        <li>Eduhint ODV, met zetel te Galileïlaan 31, 6716 BP Ede (Nederland), en met KvK-nummer 801563240B01;</li>
        <li>
          Bookwidgets - Kidimedia BV, met zetel te Leuvensesteenweg 142, 3070 Kortenberg (België), en met BTW-nummer
          0831.289.505;
        </li>
      </UnorderedList>
      <Paragraph>
        Voor onze websites en de verlening van onze diensten en/of producten delen we jouw gegevens met deze partners.
      </Paragraph>
      <Paragraph>
        AssessmentQ, Eduhint ODV en Bookwidgets gebruiken jouw persoonsgegevens teneinde de volgende data aan deze
        gegevens te koppelen:
      </Paragraph>
      <UnorderedList>
        <li>scores/ behaalde punten;</li>
        <li>punten/behaalde score per vraag;</li>
        <li>antwoord gegeven per vraag;</li>
        <li>score per oefenreeks (meerdere vragen);</li>
        <li>tijd gespendeerd.</li>
      </UnorderedList>
      <Paragraph>
        Deze partners mogen de gegevens enkel voor het vooropgestelde doel gebruiken en enkel zolang als nodig is binnen
        de samenwerking.
      </Paragraph>
      <Heading level={4}>2. Overheid en autoriteiten:</Heading>
      <Paragraph>We geven jouw gegevens door aan de overheid en autoriteiten als dat wettelijk verplicht is.</Paragraph>
      <Heading level={3}>G. Wijzigingen aan deze privacyverklaring</Heading>
      <Paragraph>
        We kunnen deze privacyverklaring aanpassen om te voldoen aan de wettelijke verplichtingen in dit verband. De
        meest recente versie vind je altijd op deze website (
        <a href={`${getRoute('PRIVACY_POLICY')}#privacy-policy`}>https://www.pelckmansportaal.be/</a>
        ).
      </Paragraph>
      <Paragraph>
        Voor elke belangrijke inhoudelijke wijziging informeren we je via onze websites of andere kanalen.
      </Paragraph>
      <Paragraph>
        Voor concrete vragen die verband houden met jouw privacy, kan je terecht op{' '}
        <a href="mailto:helpdesk@pelckmans.be">helpdesk@pelckmans.be</a>
      </Paragraph>
      <div id="cookies" />
      <Heading level={2}>Cookiebeleid</Heading>
      <Heading level={3}>Over dit cookiebeleid</Heading>
      <Paragraph>
        We maken gebruik van cookies om gebruikers van de website(s) te onderscheiden. Dit maakt het mogelijk om je een
        betere surfervaring en een verbetering van de website(s) en de inhoud ervan te bieden.
      </Paragraph>
      <Paragraph>In dit cookiebeleid leggen we, onder andere, het volgende uit:</Paragraph>
      <OrderedList type="A">
        <li>De algemene principes</li>
        <li>Welke cookies worden gebruikt en hun doeleinden</li>
        <li>De bewaartermijn</li>
        <li>Het beheer van de cookies</li>
      </OrderedList>
      <Heading level={3}>A. De algemene principes</Heading>
      <Paragraph>
        Een “Cookie” is een tekstbestand dat tijdelijk of permanent op jouw computer of mobiel wordt opgeslagen bij het
        bezoek aan onze website(s).
      </Paragraph>
      <Paragraph>
        Cookies zijn permanent wanneer zij op jouw computer blijven staan, ook nadat je de browser hebt gesloten.
        Tijdelijke cookies verdwijnen van zodra je de browser hebt gesloten.
      </Paragraph>
      <Paragraph>
        Cookies die door onze website(s) zelf worden verzonden zijn directe cookies (“eerste partijcookies” of “first
        party”).
      </Paragraph>
      <Paragraph>
        Cookies kunnen ook geïnstalleerd worden door derden met wie we samenwerken, zoals AssesmentQ, Eduhint,
        Bookwidgets, H5P, Geogebra, en Youtube (“derde partijcookies” of “third party”). Deze derden beschikken over een
        eigen privacy -en cookiebeleid, welke op hun beurt dienen te worden geraadpleegd. Derden kunnen hun privacy -en
        cookiebeleid, etc. te allen tijde wijzigen. We hebben geen controle over deze externe diensten.
      </Paragraph>
      <Paragraph>
        Sommige van de cookies die we gebruiken zijn noodzakelijk voor de goede werking van onze website(s), andere zijn
        nodig om jouw ervaring te verbeteren.
      </Paragraph>
      <Paragraph>Je kan cookies aanpassen of uitschakelen.</Paragraph>
      <Paragraph>
        Door gebruik te maken van onze website(s) stem je uitdrukkelijk in met het beheer van cookies zoals beschreven
        in dit Cookiebeleid.
      </Paragraph>
      <Heading level={3}>B. Welke cookies worden gebruikt en waarom?</Heading>
      <Paragraph>We maken gebruik van verschillende soorten cookies:</Paragraph>
      <UnorderedList>
        <li>
          Technische cookies: deze zijn noodzakelijk voor de werking van onze website(s), maken de communicatie van de
          ingevoerde gegevens mogelijk en zijn bedoeld om jouw navigatie te vergemakkelijken;
        </li>
        <li>
          Analytische cookies: deze cookies maken je herkenning mogelijk en worden gebruikt om het aantal gebruikers van
          onze website(s) over een bepaalde periode te tellen. Omdat ze ook het surfgedrag aangeven, zijn ze een
          effectieve manier om jouw surfervaring te verbeteren door voorstellen en aanbiedingen weer te geven die voor
          jouw interessant kunnen zijn. Ze maken het ons ook mogelijk eventuele bugs op onze website(s) te identificeren
          en te corrigeren;
        </li>
        <li>
          Functionele cookies: deze cookies vergemakkelijken het gebruik van onze website(s) door bepaalde ingevoerde
          keuzes te behouden (bijvoorbeeld de gebruikersnaam of taal).
        </li>
      </UnorderedList>
      <Paragraph>
        We mogen op basis van de wetgeving noodzakelijke cookies blijven gebruiken zonder jouw toestemming. Als je jouw
        cookie-keuze intrekt, heeft dat geen effect op deze cookies.
      </Paragraph>
      <Heading level={3}>C. Bewaartermijn voor cookies</Heading>
      <Paragraph>Cookies worden bewaard voor de tijd die nodig is om het beoogde doel te bereiken.</Paragraph>
      <Paragraph>
        De cookies die als gevolg van jouw bezoek aan onze website(s) op jouw harde schijf kunnen worden opgeslagen en
        de opslagperiode van deze cookies zijn als volgt:
      </Paragraph>
      <div className="cookies-table--wrapper">
        <table className="table cookies-table">
          <thead>
            <tr>
              <Cell.HeaderText title="Cookie" />
              <Cell.HeaderText title="Beschrijving" />
              <Cell.HeaderText title="Duur" />
              <Cell.HeaderText title="Aanbieder" />
            </tr>
          </thead>
          <tbody>
            <tr>
              <PrivacyTableCell title="_ga" />
              <PrivacyTableCell title="registreert een uniek ID dat gebruikt wordt om statistische data te genereren hoe je de website(s) gebruikt." />
              <PrivacyTableCell title="2 jaar" />
              <PrivacyTableCell title="Google Tag Manager / Google" />
            </tr>
            <tr>
              <PrivacyTableCell title="_gid" />
              <PrivacyTableCell title="registreert een uniek ID dat gebruikt wordt om statistische data te genereren hoe je de website(s) gebruikt, meer bepaald het groeperen van gedrag." />
              <PrivacyTableCell title="1 dag" />
              <PrivacyTableCell title="Google Tag Manager / Google" />
            </tr>
            <tr>
              <PrivacyTableCell title="_gat" />
              <PrivacyTableCell title="wordt gebruikt door Google Analytics om de verzoeksnelheid te vertragen." />
              <PrivacyTableCell title="1 dag" />
              <PrivacyTableCell title="Google Tag Manager / Google" />
            </tr>
            <tr>
              <PrivacyTableCell title="p-local" />
              <PrivacyTableCell title="wordt gebruikt om de taal bij te houden." />
              <PrivacyTableCell title="Tot het einde van de sessie" />
              <PrivacyTableCell title="Pelckmans Portaal" />
            </tr>
            <tr>
              <PrivacyTableCell title="p-authenticated" />
              <PrivacyTableCell title="wordt gebruikt om jouw login-status bij te houden." />
              <PrivacyTableCell title="Tot het einde van de sessie" />
              <PrivacyTableCell title="Pelckmans Portaal" />
            </tr>
            <tr>
              <PrivacyTableCell title="_cl" />
              <PrivacyTableCell title="houdt bij of je cookies aanvaardt" />
              <PrivacyTableCell title="1 jaar" />
              <PrivacyTableCell title="Pelckmans Portaal" />
            </tr>
          </tbody>
        </table>
      </div>
      <Heading level={3}>D. Beheer van cookies</Heading>
      <Paragraph>
        Als je niet wil dat onze website(s) cookies op jouw harde schijf plaatst, kan je deze eenvoudig beheren of
        verwijderen door jouw browserinstellingen aan te passen. Door de programmering van de browser kan je ook een
        kennisgeving ontvangen zodra onze website(s) cookies gebruiken en zo beslissen of je deze accepteert of weigert.
      </Paragraph>
      <Paragraph>
        Indien je bepaalde cookies uitschakelt, aanvaard je dat de website(s) niet optimaal functioneert. Sommige delen
        van de website(s) zijn mogelijk niet of gedeeltelijk bruikbaar.
      </Paragraph>
      <Paragraph>
        Indien je bepaalde cookies op deze manier wil beheren en/of verwijderen, kan je dit doen via de volgende
        link(s):
      </Paragraph>
      <UnorderedList>
        <li>
          Internet Explorer :
          <a target="_blank" rel="noreferrer" href="https://www.browserchecker.nl/cookies-verwijderen-instellen&#35;ie">
            https://www.browserchecker.nl/cookies-verwijderen-instellen&#35;ie
          </a>
          ;
        </li>
        <li>
          Microsoft Edge :
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.browserchecker.nl/cookies-verwijderen-instellen/cookies-verwijderen-instellen-microsoft-edge"
          >
            https://www.browserchecker.nl/cookies-verwijderen-instellen/cookies-verwijderen-instellen-microsoft-edge
          </a>
          ;
        </li>
        <li>
          Chrome :
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.browserchecker.nl/cookies-verwijderen-instellen&#35;chrome"
          >
            https://www.browserchecker.nl/cookies-verwijderen-instellen&#35;chrome
          </a>
          ;
        </li>
        <li>
          Firefox :
          <a target="_blank" rel="noreferrer" href="https://www.browserchecker.nl/cookies-verwijderen-instellen&#35;ff">
            https://www.browserchecker.nl/cookies-verwijderen-instellen&#35;ff
          </a>
          ;
        </li>
        <li>
          Safari :
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.browserchecker.nl/cookies-verwijderen-instellen&#35;safari"
          >
            https://www.browserchecker.nl/cookies-verwijderen-instellen&#35;safari
          </a>
          .
        </li>
      </UnorderedList>
      <Paragraph>
        Raadpleeg indien nodig de helpfunctie van jouw browser of surf naar{' '}
        <a target="_blank" rel="noreferrer" href="http://www.browserchecker.nl/cookies-verwijderen">
          http://www.browserchecker.nl/cookies-verwijderen
        </a>{' '}
        voor uitleg.
      </Paragraph>
      <Paragraph>
        Nog vragen? Contacteer ons via <a href="mailto:helpdesk@pelckmans.be">helpdesk@pelckmans.be</a>
      </Paragraph>
    </div>
  );
}

export default ContentNL;
